import { normalizeCellMatchMode } from "./cellMatchModeUtils";

let columnFilterIdCounter = 0;

export const createEmptyColumnFilter = () => ({
  id: `cf-${Date.now()}-${columnFilterIdCounter += 1}`,
  columnName: "",
  columnMode: "eq",
  columnValue: "",
});

export const defaultCatalogColumnFilters = () => [createEmptyColumnFilter()];

export const buildColumnFiltersPayload = (columnFilters) => (
  (columnFilters || [])
    .filter((filter) => String(filter.columnName || "").trim())
    .map((filter) => ({
      column_name: String(filter.columnName).trim(),
      column_value: String(filter.columnValue ?? "").trim(),
      column_mode: normalizeCellMatchMode(filter.columnMode || "eq"),
    }))
);
